'use es6';

import * as PopupStyles from 'feedback-schema/constants/surveyProperties/popupStyles';
export const isWebCalloutStyle = popupStyle => popupStyle === PopupStyles.CALLOUT_LEFT || popupStyle === PopupStyles.CALLOUT_RIGHT;